import React, { Component } from 'react';
import { Container, Row, Col} from 'reactstrap';
import { HashLink } from 'react-router-hash-link';

import Logo from './ui-elements/Logo';
import Arrow from './ui-elements/Arrow';

import team from '../data/team';


function getRandomArbitrary(min, max) {
    return Math.random() * (max - min) + min;
}
function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}


class SpeechBubbles extends Component {
  constructor(props){
    super(props);
    this.state = {
      texts: [
        "Pleitegriechen!",
        //"Flüchtlingskrise!",
        "Gefahr durch Milch!",
        "Krise!",
        "Trumps Haare",
        //"Taschen voll machen!",
        "Steuererhöhung!",
        "Roter Teppich für Erdogan?",
        "Rente mit 92!",
        //"Das Ende der Welt?"
      ]
    }
  }
  render(){
    return (
      <div style={{
        position: 'relative',
        width: '100%',
        height: 300,
        backgroundImage: 'url(/imgs/wellengang.png)',
        backgroundSize: '480px auto',
        backgroundPosition: 'center bottom',
        backgroundRepeat: 'repeat-x'
      }}>
        <div style={{ position: 'absolute', width: '100%', height: 300, overflow: 'hidden' }}>
          { this.state.texts.map(text => <SpeechBubble key={text} text={text} />) }
        </div>
        <img src="imgs/schiff.png" alt="Schiff" style={{
          position: 'absolute',
          left: '10vw',
          bottom: 160,
          width: '45vw',
          maxWidth: 300,
          height: 'auto',
          zIndex: 0,
          animation: 'ship 5s ease-in-out infinite',
        }}/>
      </div>
    )
  }
}

class SpeechBubble extends Component {
  render(){
    const colors = [
      'white',
      'white',
      'blue',
    ]
    const rotate = this.props.rotate || getRandomArbitrary(-6, 8);
    const scale = this.props.scale || getRandomInt(60, 80);
    const x = this.props.x || getRandomArbitrary(20, 80);
    const y = this.props.y || getRandomArbitrary(0, 40);
    const color = this.props.color || colors[Math.floor(Math.random() * colors.length)];
    const style = {
      transform: 'rotate('+rotate+'deg) scale('+scale/100+') translateX(-50%) translateY('+y+'%)',
      left: x+'%',
      position: 'absolute',
      animation: 'bounce 5s ease-in-out infinite',
      animationDelay: getRandomArbitrary(0, 2)+'s',
      zIndex: 1
    }
    return (
      <div className={ "speechbubble-" + color + " speechbubble shadow-sm" } style={style}>{ "\""+this.props.text+"\"" }</div>
    )
  }
}

const IdeaCard = (props) => {
  return (
    <div className="mx-auto pb-5">
      <img src={ "imgs/"+props.img } alt={ props.title } className="mx-auto" style={{ width: '90%', maxWidth: 200 }}/>
      <h5 className="mb-2">{ props.title }</h5>
      <small className="">{ props.text }</small>
    </div>
  )
}


const About = () => {
  return (
    <React.Fragment>

      <div className='bg-light d-flex flex-column' style={{
        flex: 1,
        position: 'relative',
        minHeight: '100vh',
      }}>
        <div className='d-flex' style={{
          flex: 1,
        }}>
          <Container className='d-flex align-items-center' style={{
            flex: 1,
          }}>
            <Col xs="12" md="7" className="mx-auto pt-5 text-center align-self-center">
              <Logo size="xl" shadow />
              <h3 className="">Ahoi Landratte!</h3>
              <p className='lead mb-4'>Wir bei Paul erleichtern den Zugang zu <strong>politischem Wissen</strong> und helfen dir so <strong>Politik aktiv mitzugestalten</strong>.</p>
            </Col>
          </Container>
        </div>
        <div className="d-flex align-items-end justify-content-center" style={{
          height: 150,
          backgroundImage: 'url(/imgs/wolken.png)',
          backgroundSize: 'auto 150px',
          backgroundPosition: 'center bottom',
          backgroundRepeat: 'repeat-x',
        }}>
          <Container fluid className="text-center">
            <p className='lead text-secondary' style={{zIndex: 5}}>Durch das Internet erreicht uns eine <strong>Flut an Informationen.</strong></p>
          </Container>
        </div>
        <div className="text-center" id="deepsea">
          <SpeechBubbles />
        </div>
        <Arrow color="primary" href="deepsea" className="d-none d-sm-flex"/>
      </div>

      <div className='bg-secondary' style={{
        flex: 1,
        backgroundImage: 'url(/imgs/bubbles.png)',
        backgroundSize: '800px auto',
      }}>
        <Container className='d-flex align-items-center py-5'>
          <Col xs="12" md="7" className="mx-auto text-center align-self-center">
            <p className='lead text-white mb-4'>Die <strong>reichhaltigsten Informationen</strong> findet man jedoch erst weit unter dem Getöse der Oberfläche. <strong>In den unbekannten Tiefen.</strong></p>
            <p className='text-white'>Deshalb stammen unsere Inhalte ausschließlich von Profis aus nationalen und internationalen Institutionen, politischen Stiftungen, ThinkTanks, NGOs etc.</p>
            <HashLink to="/content#top" className="btn btn-light text-secondary my-4 shadow-sm">Mehr über unsere Inhalte</HashLink>
          </Col>
        </Container>
        <div className="text-center" style={{
          width: '100%',
          backgroundImage: 'url(/imgs/meeresgrund.png)',
          backgroundSize: '600px auto',
          backgroundPosition: 'center bottom',
          backgroundRepeat: 'repeat-x',
          position: 'relative'
        }}>
          <div style={{ maxWidth: 300, position: 'relative' }} className="mx-auto">
            <SpeechBubble text={'Laut Studie XY ...'} color="yellow" scale={80} x={50} y={-100} rotate={3} />
            <SpeechBubble text={'Es kommt drauf an!'} color="yellow" scale={60} x={10} y={-30} rotate={-2} />
            <img src="/imgs/schatztruhe_grau.png" alt="Schatztruhe" className="mb-5" style={{
              height: 'auto',
              width: '50vw',
              maxWidth: 280,
            }}/>
          </div>
        </div>
      </div>

      <div className='bg-light py-5'>
        <Container className='pt-4 pb-5'>
          <Row className='text-center'>
            <Col xs="12" md="6" className="mx-auto pt-5 text-center align-self-center">
              <h3 className="">Unser Ziel</h3>
              <p className='lead mb-3'>Uns bei Paul ist es wichtig, diese <strong>Qualitätsinhalte</strong> an die Oberfläche zu bringen.</p>
              <p className='mb-2'>Die Bündelung ist dabei nur der Anfang.</p>
              <h6 className="text-muted pt-5 mb-3">Unsere Ideen für die Zukunft</h6>
            </Col>
          </Row>
          <Row className='text-center text-center d-flex justify-content-center pb-5'>
            <Col xs="12" md="3" className="d-flex">
              <IdeaCard title="Anreicherung" text="mit verständnisfördernden Informationen" img="idee_1_white.png" />
            </Col>
            <Col xs="12" md="3" className="d-flex">
              <IdeaCard title="Visualisierung" text="Zugänglichere gestalterische Aufbereitung" img="idee_2_white.png" />
            </Col>
            <Col xs="12" md="3" className="d-flex">
              <IdeaCard title="Vergleich" text="Gegenüberstellung verschiedener politischer Positionen" img="idee_3_white.png" />
            </Col>
          </Row>
        </Container>
      </div>

      <Container fluid className="bg-dark mt-5">
        <Col xs="12" className="py-5 text-center">
          <h6 className="text-white mb-4">Das Team</h6>
          <Row className='justify-content-center'>
            { team.map((member, index) => {
              return (
                <div className='text-center m-2' key={index} style={{ maxWidth: 190 }}>
                  <img className="mb-4 rounded-circle shadow-sm" alt={member.name} src={member.image}  style={{
                    width: '80%',
                    height: 'auto',
                  }}/>
                  <p className="text-white font-weight-bold mb-2">{member.name}</p>
                  <small className="text-white">{member.title}</small>
                </div>
              )
            })}
          </Row>
        </Col>
      </Container>

      <div className='bg-light d-none'>
        <Container className='d-flex align-items-center'>
          <div className='d-flex py-5' style={{
            position: 'relative',
            minHeight: '75vh'
          }}>
            <Col xs="12" md="6" className="mx-auto py-5 text-center align-self-center">
              <Logo size="lg" />
              <h3>Unsere Geschichte</h3>
              <p className='lead mb-4'>Wir schreiben das Jahr 2010.<br />Die zunächst allein in Griechenland aufkommende Staatsschuldenkrise nimmt ihren Lauf.</p>
              <p className='text-left'>In den Medien wird eine Endzeitstimmung heraufbeschworen, es schwirren wie selbstverständlich Begrifflichkeiten wie Troika, Hair-Cut oder IMF durch die Gegend und Schuld  sollen “die faulen Griechen” selbst sein. Im selben Jahr verzückt eine Krake namens Paul die bundesdeutsche Bevölkerung während der Fußball-WM in Südafrika durch vermeintlich hellseherische Fähigkeiten.</p>
              <p className='text-left'>Zu Hause gibt zu dieser Zeit der Wirtschaftsinformatiker Christian Röpke, der sich im Internet abseits der zumeist emotionsgeladenen Medienberichterstattung ein sachliches Bild über Ursachen und Konsequenzen der Staatsschuldenkrise zu machen versucht, frustriert auf.</p>
              <p className='text-left'><strong>Der Grund?</strong><br />Bei Google findet er außer der tagesaktuellen Berichterstattung nur schwer seriöse Artikel und Analysen, welche ihm möglichst niedrigschwellig und sachlich die Staatsschuldenkrise und deren Hergang, Akteure sowie Konsequenzen erklären. Da sehnt sich Christian Röpke die scheinbar magischen Kräfte der Krake Paul herbei, die ihm dabei helfen könnte aus dem Meer des politischen Wissens den passenden Happen herauszusuchen. Er findet ihn in der Person seines langjährigen Freundes Christian Bergmann, der Politikwissenschaftler ist und tagtäglich mit genau den Artikeln und Analysen zu tun hat, nach denen Christian Röpke so verzweifelt sucht.</p>
              <p className='text-left'><strong>Das Problem?</strong><br />Bei Google sind solche Artikel und Analysen wenn, dann nur sehr schwer (ab Seite 5 und folgende) oder gleich gar nicht zu finden. Es bedarf also eines gewissen Vorwissens über Organisationen und Institutionen, die zu Themen wie etwa der Staatsschuldenkrise etwas publiziert haben. Christian B. empfiehlt seinem Freund Christian R. also Publikationen von Think Tanks wie etwa dem Institut für Makroökonomie und Konjunkturforschung (IMK), einem Wirtschaftsforschungsinstituts der gewerkschaftsnahen Hans-Böckler-Stiftung. Da das IMK allein jedoch noch kein politisch differenziertes Bild über das Thema vermitteln kann, empfiehlt Christian B. sich kontrastierend Analysen des wirtschaftsnahen Leibniz-Instituts für Wirtschaftsforschung an der Universität München (ifo) anzuschauen. Christian R. ist überwältigt: Wie konnte ein solch schier unglaubliches, frei verfügbares Wissensangebot so spurlos an ihm vorbeigehen? Christian R. und Christian B. hatten von nun an einen Plan.</p>
              <p className='text-left'><strong>Die Lösung?</strong><br />Nach beruflichen Irrungen und Wirrungen beschließen die beiden im Sommer 2017 die Passion zur Profession zu machen und dem Begriff der “Datenkrake” einen gehörigen positiven Imagewechsel zu verpassen. Unter der technischen Leitung des Wirtschaftsinformatikers Christian R. und der inhaltlichen Leitung des Politikwissenschaftlers Christian B. soll nun eine Suchplattform names Paul Open Search ins Leben gerufen werden, welche es sich zum Ziel gesetzt hat das immense Publikationsangebot politischer Stiftungen, Think Tanks, NGOs, Verbände u.a. rund um gesellschaftspolitische Themen unserer Zeit an einem zentralen Ort zu bündeln - schnell, divers & nutzerfreundlich.</p>
            </Col>
          </div>
        </Container>
      </div>

      <Container fluid className="bg-light-gray py-5">
        <Container className="text-center">
          <small className="text-muted d-block mb-4">Wir werden unterstützt von</small>
          <div>
            <img src='/imgs/support_logos/eu_sozialfonds.png' alt="Europäischer Sozialfonds" className='img-fluid m-3' style={{ maxWidth: 240 }}/>
            <img src='/imgs/support_logos/logo_hwr.png' alt="Startup Incubator Berlin" className='img-fluid m-3' style={{ maxWidth: 240 }} />
          </div>
        </Container>
      </Container>

  </React.Fragment>
  );
}

export default About;


/*

<div className='d-flex flex-column justify-content-center' style={{flex: 1}}>
    <div className='container pt-5'>
          <div className='row'>
              <div className='col-10 col-xl-8 offset-1 offset-xl-2'>

              </div>
          </div>
    </div>
    <div className="container-fluid bg-light-gray py-5">
        <div className='container'>
            <p className="text-muted">Wir werden unterstützt von</p>
            <div className='row'>
                <div className='col-12 col-sm-6 col-md-4 col-lg-3 p-4 align-self-center'><img src='/imgs/support_logos/eu_sozialfonds.png' className='supportLogo' /></div>
                <div className='col-12 col-sm-6 col-md-4 col-lg-3 p-4 align-self-center'><img src='/imgs/support_logos/logo_hwr.png' className='supportLogo' /></div>
            </div>
        </div>
    </div>
</div>

*/



// WEBPACK FOOTER //
// ./src/components/About.js